import { UserDataFragment, useUpdateCallListMembersMutation } from "@bonliva-crm/graphql";
import { CallOrContactList, HookProps } from "../utils";

export function useUpdateCallListMembers(props: HookProps) {
  const [updateCallListMembersMutation] = useUpdateCallListMembersMutation({
    onError: (e) => {
      console.error(e);
      props.onError && props.onError(e);
    },
    onCompleted: () => {
      props.onCompleted && props.onCompleted();
    }
  });

  const updateCallListMembers = (args: {
    callList: CallOrContactList;
    selectedUsers: UserDataFragment[];
  }) => {
    updateCallListMembersMutation({
      variables: {
        callListId: args.callList._id,
        userIds: args.selectedUsers.map((user) => user._id)
      },
      optimisticResponse: () => {
        return {
          setCallListMembers: {
            callList: {
              ...args.callList,
              members: args.selectedUsers.map((user) => ({
                Name: user.Name,
                PersonId: user._id
              }))
            }
          }
        };
      }
    });
  };

  return { updateCallListMembers };
}
